import React, { useState, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { useFormik } from "formik";
import classNames from "classnames";
// import { handlePostRequest } from "../../../services/PostTemplate";
// import { handlePutRequest } from "../../../services/PutTemplate";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const ReleaseDetails = ({ onHide, roleRowData, getRoles }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");

    const cancelHandler = (e) => {
        e.preventDefault();
    };

    useEffect(() => {
        if (!roleRowData === undefined || !roleRowData === null) {
            formik.setFieldValue("roleDescr", roleRowData.roleDescr);
        }
    }, [roleRowData]); // eslint-disable-line

    const formik = useFormik({
        initialValues: {
            roleDescr: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.roleDescr) {
                errors.roleDescr = "This field is required.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            // if (editable === true) {
            //     await handlePutRequest(data, `zbiz/nonFin/updateRole`);
            // } else {
            //     await handlePostRequest(data, "zbiz/nonFin/saveRole");
            // }
            await getRoles();
            onHide();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Dialog__Round">
                    <div className="Form__Header">
                        <h1>Release Details</h1>
                    </div>
                    <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                        <table className="Dialog__Table">
                            <tr>
                                <th>Debit Acct No</th>
                                <th>Debit Account</th>
                                <th>Credit Acct No</th>
                                <th>Cheque Number</th>
                                <th>Payment Details</th>
                            </tr>
                            <tr>
                                <td>08987654321</td>
                                <td>1098</td>
                                <td>09876543321</td>
                                <td>325422</td>
                                <td>Paid</td>
                            </tr>
                        </table>
                        <br />
                        <div className="Dialog__DownBtn">
                            <Button label="Cancel" className="DialogBtn__Transparent" onClick={(e) => cancelHandler(e)} />
                            <Button disabled={loading} label="Release" className="DialogBtn__Dark" />
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ReleaseDetails;
